import React from 'react';
import { Control, useFieldArray, UseFieldArrayReturn } from 'react-hook-form';
import { memoizeField } from './memoizeField';
import FieldWrapper, { FormMethods } from './FieldWrapper';

type Props = {
  name: string
  control?: Control,
  children: (name: string, args: UseFieldArrayReturn) => React.ReactNode
} & FormMethods

export const formatName = (name: string, index: number) => {
  return `${name}[${index}]`;
};

function FieldArray({ name, control, formMethods, children }: Props) {
  const fieldArray = useFieldArray({
    name,
    control: formMethods?.control || control,
  });

  return (
    <>
      {children(name, fieldArray)}
    </>
  );
}

export default FieldWrapper(memoizeField(FieldArray));
